import { render, staticRenderFns } from "./TextAlignJustifyIcon.vue?vue&type=template&id=d04ad4dc&"
import script from "./TextAlignJustifyIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignJustifyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports